import React from 'react'
import { Box, Flex } from "@chakra-ui/react";
import { AlertCard } from './AlertCard';

export const AlertSection = () => {
  return (
    <Flex direction={["column", "column", "row"]}>
      <Box w={["100%", "100%", "33%"]}>
        <Box m="5px">
          <AlertCard text="Water Low Level Alert" />
        </Box>
        <Box m="5px">
          <AlertCard text="Gas Low Level Alert" />
        </Box>
      </Box>
      <Box w={["100%", "100%", "33%"]}>
        <Box mt="5px" mr="5px">
          <AlertCard text="Water Leakage Alert" />
        </Box>
        <Box mr="5px" mt="5px">
          <AlertCard />
        </Box>
      </Box>
      <Box w={["100%", "100%", "33%"]}>
        <Box mt="5px">
          <AlertCard text="Energy Low Level Alert" />
        </Box>
        <Box mt="5px">
          <AlertCard />
        </Box>
      </Box>
    </Flex>
  );
}
